<template>
	<div :class="buttonType ? [buttonType] + ' button' : 'button'" @click="onClick">
		<i v-if="hasIcon" class="button-icon material-icons">{{ iconName }}</i>
		<div>{{ title }}</div>
	</div>
</template>

<script>
export default {
	name: "button",
	props: {
		iconName: String,
		hasIcon: Boolean,
		title: String,
		onClick: Function,
		// eslint-disable-next-line vue/require-prop-type-constructor
		buttonType: "normal" | "outline",
	},
};
</script>

<style scoped lang="scss">
.button {
	background-color: var(--accent);
	border: 1px solid var(--accent);
	color: var(--white);
	border-radius: 32px;
	// height: 60px;
	height: 48px;
	max-width: 500px;
	width: 170px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	font-style: normal;
	font-weight: 500;
	font-size: 18px;
	line-height: 27px;
	text-align: center;
	cursor: pointer;
}
.outline {
	// border: 1px solid var(--white);
	border: 1px solid var(--accent);
	color: var(--accent);
	background-color: transparent;
}
@media screen and (max-width: 414px) {
	.button {
		border-radius: 30px;
		height: 48px;
	}
}
</style>
